import {Component, OnInit, ChangeDetectionStrategy} from '@angular/core';
import {UntypedFormBuilder, UntypedFormGroup, Validators} from '@angular/forms';
import {StudentService} from '../../_services/student.service';
import moment from 'moment';
import {Router} from '@angular/router';
import {ToolsService} from '../../_services/tools.service';
import {Formula, Student} from '../../models/eventRequest';

declare let $: any;

@Component({
    selector: 'app-create-student',
    templateUrl: './create-student.component.html',
    styleUrls: ['../student-save/student-save.component.css', './create-student.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class CreateStudentComponent implements OnInit {

  formulas: Formula[] = [];
  newStudentForm = this.fb.group({
    sexe: ["", Validators.required],
    formulaId: [null, Validators.required],
    neph: [null],
    firstname: [null, Validators.required],
    lastname: [null, Validators.required],
    email: [null, [Validators.required, Validators.email]],
    birthDate: [null, Validators.required],
    birthPlace: [null, Validators.required],
    phoneNumber: [null, [Validators.required, Validators.pattern("0[0-9]{9}")]],
    address: [null, Validators.required],
    postalCode: [null, Validators.required],
    city: [null, Validators.required],
    contractDate: [null],
    settlementDate: [null],
    evaluationDate:[null],
    evaluationHours:[null],
    agreedNumberHours:[null],
    registrationDate: [moment(new Date()).format('YYYY-MM-DD'), Validators.required],
    hasCode: [null, Validators.required]
  });
  submited: boolean = false;
  saving = false;
  messageError: string = "";
  /** Élèves au statut « À créer » (page de 50, la plus récente). */
  studentsToCreate: Student[] = [];
  studentsToCreateTotal = 0;
  showStudentsToCreate = true;

  constructor(private fb:UntypedFormBuilder, private studentService: StudentService,
              private toolsService: ToolsService, private router: Router) {

    toolsService.getActiveFormulas().subscribe(
      formulas => {
        this.formulas = formulas;
      },
      err => {
        this.messageError = err.error.message;
      });

    studentService.getStudentsToCreate(0, 50).subscribe(page => {
      this.studentsToCreate = page?.content ?? [];
      this.studentsToCreateTotal = page?.totalElements ?? this.studentsToCreate.length;
    });
  }

  consultStudent(id: bigint) {
    this.router.navigate(['students/' + id]);
  }

  ngOnInit(): void {
    //$("#registrationDate").prop('disabled', true)
   // this.newStudentForm.controls["registrationDate"].disable();
  }

  onCreateStudent() {
    return this.newStudentForm.valid;
  }

  /** Champ en erreur, affiché seulement après une tentative de création. */
  invalid(name: string): boolean {
    const control = this.newStudentForm.get(name);
    return this.submited && !!control && control.invalid;
  }

  isSubmited(form: UntypedFormGroup) {
    this.submited = true;
    if (!form.valid || this.saving) {
      return;
    }

    this.saving = true;
    this.studentService.createStudent(form.value).subscribe(
      data => {
        this.messageError = "";
        this.router.navigate(['students/' + data.id]);
      },
      err => {
        this.saving = false;
        this.messageError = err?.error?.message || (typeof err?.error === 'string' ? err.error : "La création de l'élève a échoué.");
        window.scrollTo({top: 0, behavior: 'smooth'});
      }
    );
  }
}
